export default function Button({
  type = "button",
  variant = "default",
  size = "md",
  loading = false,
  iconOnly = false,
  leftIcon = null,
  rightIcon = null,
  className = "",
  children,
  disabled,
  "aria-label": ariaLabel,
  ...props
}) {
  const variantMap = {
    default: "secondary",
    gold: "primary",
    green: "primary",
    blue: "secondary",
  };
  const normalizedVariant = variantMap[variant] || variant;
  const classes = ["btn", `btn-${normalizedVariant}`, `btn-${size}`];

  if (variant !== normalizedVariant) {
    classes.push(`btn-${variant}`);
  }

  if (iconOnly) {
    classes.push("btn-icon-only");
  }

  if (loading) {
    classes.push("btn-loading");
  }

  if (className) {
    classes.push(className);
  }

  return (
    <button
      type={type}
      className={classes.join(" ")}
      disabled={disabled || loading}
      aria-label={ariaLabel || (iconOnly ? "Button" : undefined)}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading ? <span className="btn-spinner" aria-hidden="true" /> : leftIcon}
      {children ? <span className="btn-label">{children}</span> : null}
      {!loading ? rightIcon : null}
    </button>
  );
}
